import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { getTwilioBrand } from 'api/admin/businesses/twilioIntegration';
import { TwilioQueryKeys } from 'constants/twilio/twilioQueryKeys';
import { TwilioBrandDetailsHttpResponse } from 'types/twilio/twilioBrand';

export const useGetTwilioBrand = (
  businessId: number,
  brandId: string | null | undefined,
) => {
  const { isLoading, error, data, refetch } = useQuery<
    unknown,
    AxiosError<{ error: string }>,
    TwilioBrandDetailsHttpResponse
  >({
    queryKey: [TwilioQueryKeys.BRAND, businessId],
    queryFn: async () => {
      const response = await getTwilioBrand(businessId, brandId!);

      return response.data;
    },
    enabled: !!brandId,
    onError: (error) => {
      Sentry.captureException(error);

      toaster(
        error?.response?.data?.error ?? 'An error occurred while fetching Twilio brand',
        {
          icon: '❌',
        },
      );
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
